import React from "react";
import { compose } from 'recompose';
import { translate } from "react-admin"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    FormControl,
    FormLabel,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    RootRef,
    Typography,
} from "@material-ui/core";
import { createStyles } from '@material-ui/core/styles';

//input(会議室情報)のIDと名前を管理
const GetResourceMap = (resources) => Array.from(resources).reduce((acc, resource) => acc.set(resource.id, resource.name), new Map());

const labelStyle = () => createStyles({
    color: "rgba(0, 0, 0, 0.54)",
    padding: "0em",
    fontSize: "0.8rem",
})

const itemStyle = (draggableStyle, isDragging) => createStyles({
    ...draggableStyle,
    ...(isDragging ? { background: "rgb(135,135,135)" } : { background: "rgb(240,240,240)" }),
    paddingLeft: "0.5em",
    paddingRight: "1em",
    paddingTop: "0.5em",
    paddingBottom: "0.5em",
    maxWidth: "30em",
    border: "0.2em solid rgb(255,255,255)",
    borderRadius: 4,
});

const OrderedList = (props) => {

    const { record, translate, input } = props;
    const { type } = record;
    const droppableId = "resource-list";

    const ResourceMap = GetResourceMap(input.value);

    const onDragEnd = result => {

        const { destination, source, draggableId } = result

        //変更なければスキップ
        if (!destination || (destination.index === source.index)) return;

        //inputのコピーに対して並び替えを反映
        //TODO なぜかArray.from()の結果でドラッグされた要素のresource.nameが欠落するため、毎回要素を作り直して格納
        const newValues = Array.from(input.value)
        newValues.splice(source.index, 1);
        newValues.splice(destination.index, 0, {id:draggableId, name:ResourceMap.get(draggableId)})

        //並び替えた内容でinputを更新
        input.onChange(newValues)
    }

    return (
        <div>
            { type == 1 ?
                <FormControl>
                    <FormLabel style={labelStyle()}>
                        {translate('resources.terminals.fields.resources')}
                    </FormLabel>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={droppableId}>
                            {(dropProvided, dropSnapshot) => (
                                <RootRef rootRef={dropProvided.innerRef}>
                                    <List>
                                        {Array.from(input.value).map((resource, index) => (
                                            <Draggable key={resource.id} draggableId={resource.id} index={index}>
                                                {(dragProvided, dragSnapshot) => (
                                                    <ListItem
                                                        ContainerProps={{ ref: dragProvided.innerRef }}
                                                        {...dragProvided.draggableProps}
                                                        {...dragProvided.dragHandleProps}
                                                        style={itemStyle(dragProvided.draggableProps.style, dragSnapshot.isDragging)}
                                                    >
                                                        <ListItemText primary={
                                                            <Typography noWrap={true}>
                                                                {resource.name}
                                                            </Typography>
                                                        } />
                                                        <ListItemSecondaryAction />
                                                    </ListItem>
                                                )}
                                            </Draggable>
                                        ))}

                                        {dropProvided.placeholder}
                                    </List>
                                </RootRef>
                            )}
                        </Droppable>
                    </DragDropContext>
                </FormControl> : noop}
        </div>
    )
}

const noop = () => { }

const enhance = compose(
    translate
);

export default enhance(OrderedList);
